import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-down-left', 'ChevronDownLeft', [["path",{"d":"M7.879 7.636v8.485h8.485","key":"svg-0"}]]);